module.exports = __webpack_public_path__ + "static/product-l0970-charcoal-a2673e5426136c85ae2064fb9729823a.png";